<template>
  <div>
    <adv-button
      class="launch-quick-view"
      v-on:btn-click="toggleQuickView"
      v-show="showQuickView">
      <i class="lni lni-eye"></i>
    </adv-button>

    <adv-button
      v-if="hasAttributes"
      class="addtoCart"
      v-on:btn-click="toggleQuickView"
      v-show="showAddToCart"
      v-html="buttonBuyText">
    </adv-button>

    <adv-cart-button
      v-else
      :quantity="quantity"
      :stock="stock"
      v-on:btn-click="btnBuyClicked"
      v-on:btn-click-no-stock="btnBuyClickedNoStock"
      :progress="progress"
      v-show="showAddToCart"
      :disabled="setDisabled"></adv-cart-button>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'
import AdvCartButton from './AdvCartButton'

export default {
  name: 'AdvButtonViewBuy',
  mixins: [productMixin, onlineMixin, cartButtonMixin],
  props: {
    productId: {
      type: Number,
      default: null
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: true
    },
    showContent: {
      type: Boolean,
      default: true
    },
    showQuickView: {
      type: Boolean,
      default: false
    },
    showAddToCart: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AdvCartButton,
    AdvButton
  },
  data () {
    return {
      version: '0.0.1',
      quickViewVisible: false,
      progress: false
    }
  },
  computed: {
    setDisabled () {
      return this.stock <= 0 || !this.onlineStatus
    },
    quantity () {
      return store.getters.cartProductCodeQuantity(this.productData.productCodes[0].productCodeId)
    },
    hasAttributes () {
      return this.productData.productCodes.length > 1
    },
    quickViewButtonVisible () {
      return store.getters.productCardModal.open
    },
    stock () {
      return this.productData.productStock
    },
    buttonBuyText () {
      if (this.stock <= 0) {
        return 'ΣΥΝΤΟΜΑ ΚΟΝΤΑ ΣΑΣ'
      }

      return 'ΣΤΟ ΚΑΛΑΘΙ'
    }
  },
  methods: {
    toggleQuickView () {
      if (store.state.productCardModal.open) {
        store.dispatch('closeProductCardModal')
      } else {
        store.dispatch('openProductCardModal', this.productId)
      }
    },
    btnBuyClicked () {
      this.progress = true
      store.dispatch('addToCartClicked', { productCodeId: this.productData.productCodes[0].productCodeId, quantity: this.quantity })
        .then(() => {
          this.progress = false
        })
    },
    btnBuyClickedNoStock () {
      // for clients that need click event without stock on button
    }
  }
}
</script>
